import {DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import {DatePickerInput} from '@mantine/dates';
import React from 'react';

import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';

import {formatToISODate, parseISODate} from './DateEditorUtils';

export interface DateEditorProps {
  config: string | null;
  configShape: GetPipelineConfigSpecType<'date'>;
  onChangeConfig: (config: string | null) => void;
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function DateEditor({
  config,
  configShape,
  onChangeConfig,
  disabled,
  dataTestAttrs = {},
}: DateEditorProps): JSX.Element {
  const handleChange = (date: Date | null): void => {
    onChangeConfig(formatToISODate(date));
  };

  return (
    <DatePickerInput
      disabled={disabled}
      // @ts-expect-error Mantine's DatePickerInput props inherit from `button`, not from `input`, so
      // `placeholder` does not exist where it should.
      placeholder="Select date"
      value={parseISODate(config)}
      onChange={handleChange}
      clearable={!configShape.required}
      styles={{
        input: {
          flexGrow: 1,
          borderRadius: '4px',
          height: '36px',
        },
      }}
      {...getTestProps(dataTestAttrs)}
    />
  );
}
